import React, { useState, useEffect } from "react";
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './Holidays.css';
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import AddNewHoliday from "./AddNewHoliday";
import { FiSearch } from "react-icons/fi";
import FadeLoader from "react-spinners/FadeLoader";

const Holidays = ({ refreshTrigger }) => {
    const [rowsData, setRowsData] = useState([]);

    const [isHolidayPopupOpen, setIsHolidayPopupOpen] = useState(false);
    const [editPopup, setEditPopup] = useState(false);
    const [userData, setUserData] = useState(null);
    // const [allyear, setAllYear] = useState([]);
    const [region, setRegion] = useState("United States");
    const [loader, setLoader] = useState(false);
    const intialYear = new Date().getFullYear();
    const [currentYear, setCurrentYear] = useState(intialYear);
    const [allRecords, setAllRecords] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [loading, setLoading] = useState(false);

    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const maxYear = intialYear + 10;

    const allYears = Array.from({ length: maxYear - intialYear + 1 }, (_, index) => intialYear + index);

    const handleYearChange = (e) => {
        const selected = parseInt(e.target.value);
        setCurrentYear(selected);
    };
    useEffect(() => {
        const filtered = allRecords.filter(item => {
            const matchRegion = item.region?.toLowerCase() === region?.toLowerCase();
            // const matchYear = Number(item.year) === Number(currentYear);
            const search = searchValue.trim().toLowerCase();
            const matchSearch =
                item.name?.toLowerCase().includes(search) ||
                item.dateName?.toLowerCase().includes(search);
            return matchRegion && (!search || matchSearch);
        }
        );
        setRowsData(filtered);
    }, [region, allRecords, searchValue]);

    const fetchHolidays = async () => {
        setLoader(true);
        try {
            const response = await fetch(`${hostPath}/api/GetAllHolidays`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": `${hostHeader}`
                },
                body: JSON.stringify({
                    Region: region,
                    Year: currentYear
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            const formattedData = data.map(item => ({
                id: item.id,
                name: item.name,
                dateName: item.dateName,
                createdDate: item.createdDate,
                year: item.year,
                month: item.month,
                day: item.day,
                week: item.week,
                date: item.date,
                isActive: item.isActive,
                region: item.region?.trim(),
                holidayType: item.holidayType,
                lastUpdatedDate: item.lastUpdatedDate
            }));

            setAllRecords(formattedData);
            setRowsData(formattedData);

        } catch (error) {
            setLoader(false);
            console.error("Error fetching holidays:", error);
        }
        finally {
            setLoader(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        //setLoader(true);
        fetchHolidays();
    }, [hostPath, currentYear, refreshTrigger]);


    const handleAddNewHoliday = () => {
        setIsHolidayPopupOpen(true);
        setUserData(null);
    }
    const handleCancelHoliday = () => {
        setIsHolidayPopupOpen(false);
        setEditPopup(false)
    }
    const handleEdit = (row) => {
        setIsHolidayPopupOpen(true);
        setEditPopup(true);
        setUserData(row)
    }


    const handleDelete = async (row) => {
        setLoader(true);
        const rowID = row.id;
        try {
            const response = await fetch(`${hostPath}/api/DeleteHolidayByID`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "x-functions-key": `${hostHeader}`
                },
                body: JSON.stringify({ id: rowID })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            fetchHolidays();
        } catch (error) {
            console.error("Error deleting holiday:", error);
        }
    };

    return (
        <>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}

            <div className="parking-lot-container">
            </div>
            {isHolidayPopupOpen &&
                <div className="holiday-popup-overlay">
                    <div className="holiday-popup-content">
                        <AddNewHoliday handleCancelHoliday={handleCancelHoliday} setEditPopup={setEditPopup} editPopup={editPopup} holidayData={userData} fetchHolidays={fetchHolidays} setIsHolidayPopupOpen={setIsHolidayPopupOpen} setLoading={setLoading} setLoader={setLoader} loading={loading} loader={loader}
                        />
                    </div>
                </div>
            }
            <br />
            <Divider
                sx={{
                    height: "2px",
                    backgroundColor: "#8B8B8B",
                    borderRadius: "1px",
                    marginTop: "10px"
                }}
            />
            <br />
            <div className="filter-container">

                <div className="filter-row">
                    <span>Filter by:</span>
                    <select value={region} onChange={(e) => setRegion(e.target.value)}>
                        <option value="United States">United States</option>
                    </select>


                    <div className="year-input-container">
                        <select value={currentYear} onChange={handleYearChange} className="year-dropdown">
                            {allYears.map((year) => (
                                <option key={year} value={year}
                                    disabled={year < intialYear}
                                >
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>



                </div>
                <div className="search-field">
                    <input type="search" name="search" placeholder="Search..." onChange={(e) => setSearchValue(e.target.value)} />
                    <button className="search-button">
                        <FiSearch />
                    </button>
                </div>
            </div>
            <br />


            
            <TableContainer component={Paper} sx={{ maxHeight: '505px', overflow: 'auto' }}>
                <Table sx={{ tableLayout: "auto", width: "100%" }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Holiday Name</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rowsData.length > 0 ? (
                            rowsData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>
                                        {row.dateName}
                                    </TableCell>
                                    <TableCell>  <>
                                        <FiEdit3 title="Edit" aria-label="Edit"
                                            style={{
                                                width: "38px",
                                                height: "25px",
                                                padding: "2px 2px",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                marginRight: "5px"
                                            }}
                                            onClick={() => handleEdit(row)}
                                        />
                                        <FiTrash2 title="Delete" aria-label="Delete"
                                            style={{
                                                width: "38px",
                                                height: "25px",
                                                padding: "2px 2px",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                marginRight: "5px"
                                            }}
                                            onClick={() => handleDelete(row, 'trash')}
                                        />


                                    </></TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    No Holidays Found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

        </>
    );
}

export default Holidays;
